import { render, staticRenderFns } from "./AddConsultation.vue?vue&type=template&id=78df80c6&scoped=true"
import script from "./AddConsultation.vue?vue&type=script&lang=js"
export * from "./AddConsultation.vue?vue&type=script&lang=js"
import style0 from "./AddConsultation.vue?vue&type=style&index=0&id=78df80c6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78df80c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78df80c6')) {
      api.createRecord('78df80c6', component.options)
    } else {
      api.reload('78df80c6', component.options)
    }
    module.hot.accept("./AddConsultation.vue?vue&type=template&id=78df80c6&scoped=true", function () {
      api.rerender('78df80c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/reinbursement/components/AddConsultation.vue"
export default component.exports